import React, { Fragment, useEffect, useState } from 'react';
import { Menu } from 'tea-component';
import { useHistory, useLocation } from 'umi';
import SvgIcon from '@home/components/SvgIcon';
import useIntls from '@opm/hooks/useIntls';

export default function NavBody(props: any) {
  const { intl, isEn } = useIntls();
  const history = useHistory();
  const { listMenu, isExpand, toggleExpand } = props;
  const location = useLocation();
  const [openMenuList, setOpenMenuList] = useState<Array<string>>([]);

  useEffect(() => {
    const newOpenMenuList: string[] = [];
    listMenu.forEach((item: any) => {
      newOpenMenuList.push(item.title);
      item.children?.forEach((child: any) => {
        /// 箭头专区默认展开
        if (child.children?.length && child.title === 'Arrows') {
          newOpenMenuList.push(`${item.title}_${child.title}`);
        }
      });
    });
    setOpenMenuList(newOpenMenuList);
  }, [listMenu]);

  function getSelectedKey(href: string) {
    return location.pathname.includes(href);
  }

  function getBetaIconElement(hasBeta: boolean) {
    if (hasBeta) {
      return <span className="left-nav-notice beta">BETA</span>;
    }
    return null;
  }

  function getSubMenuBetaIconElement(item: any) {
    if (item.hasBeta) {
      return null;
    }
    // 只有收起时才显示 BETA 徽章
    if (openMenuList.includes(item.title)) {
      return null;
    }
    if (item.children?.some((child: any) => child.hasBeta)) {
      return <span className="left-nav-notice beta">BETA</span>;
    }
    return null;
  }

  function onOpenedChange(opened: boolean, title: string) {
    setOpenMenuList((prev) => {
      if (opened) {
        return prev.includes(title) ? prev : [...prev, title];
      }
      return prev.filter((item) => item !== title);
    });
  }

  const renderChildItem = (child: any, subChild = false) => {
    return (
      <Menu.Item
        onClick={() => history.push(child.href)}
        key={child.href || child.title}
        title={
          <div className={subChild ? 'left-nav-text-hd-flex-sub' : 'left-nav-text-hd-flex'}>
            <span className="menu-context-text">
              {isEn ? child.title : child.titleCn}
            </span>
            {getBetaIconElement(child.hasBeta)}
          </div>
        }
        selected={getSelectedKey(child.href)}
      />
    );
  };

  const renderChildren = (children: any[], parentTitle: string) => {
    return children.map((item: any) => {
      const menuKey = `${parentTitle}_${item.title}`;
      if (item.children?.length) {
        const isOpen = openMenuList.includes(menuKey);
        const hasActiveLeaf = item.children.some((leaf: any) =>
          getSelectedKey(leaf.href),
        );
        return (
          <Fragment key={menuKey}>
            <div className="dbom-three-level-box">
              <p className={`dbom-three-level-title${hasActiveLeaf && !isOpen ? ' dbom-three-level-selected' : ''}`}
                onClick={() => {
                  const close = openMenuList.includes(menuKey);
                  onOpenedChange(!close, menuKey);
                }}
              >
                <span className="menu-context-text">
                  {isEn ? item.title : item.titleCn}
                </span>
                {getBetaIconElement(item.hasBeta)}
                <i
                  className={`tea-icon tea-icon-arrowdown ${isOpen ? 'is-expanded' : ''}`}
                  role="img"
                  aria-label="arrowdown"
                />
              </p>
              <div
                style={{
                  display: isOpen ? 'block' : 'none',
                }}
              >
                {item.children.map((leaf: any) => renderChildItem(leaf, true))}
              </div>
            </div>
          </Fragment>
        );
      }
      return (
        <Fragment key={menuKey}>
          {renderChildItem(item, parentTitle.includes('_'))}
        </Fragment>
      );
    });
  };

  return (
    <div className="navmenu-bd dbom-nav-menu-bd">
      {isExpand ? (
        <Menu title={intl({ id: 'Marketing Hub' })}>
          {listMenu.map((item: any) => {
            return (
              <Menu.SubMenu
                icon={
                  <SvgIcon className="left-nav-icon" type={item.icon}></SvgIcon>
                }
                key={item.title}
                title={
                  <div className="left-nav-hd">
                    <span className="menu-context-text">
                      {isEn ? item.title : item.titleCn}
                    </span>
                    {getBetaIconElement(item.hasBeta)}
                    {getSubMenuBetaIconElement(item)}
                  </div>
                }
                opened={openMenuList.includes(item.title)}
                onOpenedChange={(opened) => onOpenedChange(opened, item.title)}
              >
                {renderChildren(item.children, item.title)}
              </Menu.SubMenu>
            );
          })}
        </Menu>
      ) : (
        <div className="width-item">
          <div className="header-width" onClick={() => toggleExpand()}>
            <SvgIcon className="header-width-title" type="market-hub" />
          </div>
          {listMenu.map((e: any) => (
            <div
              key={e.id}
              className="width-item-icon"
              onClick={() => toggleExpand()}
            >
              <SvgIcon type={e.icon} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
